import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { CommonPagePromo } from 'components/no-auth/common/CommonPagePromo';
import { LightButton } from 'components/no-auth/common/fromAuth/LightButton/LightButton';
import { LightDangerouslyHtml } from 'components/no-auth/common/fromAuth/LightDangerouslyHtml/LightDangerouslyHtml';
import { LightHeaderPanel } from 'components/no-auth/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { MobileTextComponent } from 'components/no-auth/help/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toggleChat } from 'actions/chatAction';

import { LightDiskButton } from '../../components/no-auth/common/fromAuth/LightDiskButton/LightDiskButton';
import { useGetQueryParams } from '../../components/no-auth/utils';
import { AUTH_SEND_MAIN_LINK } from '../../constants/UrlConstants';
import { getLangCountryPrefix } from '../../helpers/utils';

const ZendeskHelpMobileArticlePage = (props) => {
    const article = props.article;
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const navigate = useNavigate();
    const location = useLocation();
    const { platform } = useGetQueryParams();

    const handleToggleChat = (e) => {
        e.preventDefault();
        platform === 'ios' || platform === 'android' ? navigate(`${location.pathname}/showChat`) : props.toggleChat(true);
    };

    return (
        <CommonPagePromo
            backUrl={`${url}/category/${props.category.id}/section/${props.article.section_id}`}
            type={'tagA'}
            buttonId={'helpPageBackButton'}
            rightHeaderComponent={<LightDiskButton type={'tagA'} href={AUTH_SEND_MAIN_LINK} iconName={'cross'} id={'helpPageCloseButton'} />}
        >
            <LightHeaderPanel title={article?.title} />
            <MobileTextComponent>
                <LightDangerouslyHtml dangerouslyHtml={article?.body} />
            </MobileTextComponent>
            <LightButton
                caption={props.chatButtonCaption}
                variant={'row'}
                textCenter
                negativeMargin
                onClick={(e) => handleToggleChat(e)}
                id={'helpPageChatButton'}
            />
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    chatButtonCaption: extra?.strapiApi?.chat_btn_mobile,
    opinionText: extra?.strapiApi?.opinion_text,
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    article: extra?.zendeskHelpData?.article,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpMobileArticlePage));
